import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SupportWidgetComponent } from './support-widget/support-widget.component';
import { SupportTicketListComponent } from './support-ticket-list/support-ticket-list.component';
import { SupportTicketFormComponent } from './support-ticket-form/support-ticket-form.component';
import { SupportTicketDetailComponent } from './support-ticket-detail/support-ticket-detail.component';
import { SupportAssistantComponent } from './support-assistant/support-assistant.component';

@NgModule({
    declarations: [
        SupportWidgetComponent,
        SupportTicketListComponent,
        SupportTicketFormComponent,
        SupportTicketDetailComponent,
        SupportAssistantComponent,
    ],
    imports: [CommonModule, FormsModule],
    exports: [SupportWidgetComponent],
})
export class SupportModule {}
